import { useQuery } from 'react-query'
import AdxSortTable from 'components/reusable/table/AdxSortTable'
import Column2 from 'module/claim/pages/overview/components/tab-panels/lists/unsubmitted/Column2'
import Column1 from 'module/claim/pages/overview/components/tab-panels/lists/unsubmitted/Column1'
import { getQueryReports } from 'services/api/modules/claim/report'
import { ReportIconConstructor } from '../../functions'
import { Box } from '@mui/system'
import { Skeleton, Typography } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import reportStatusConverter from 'module/claim/services/helper/reportStatusConverter'
import AdxEmptyStateV2 from 'components/reusable/emptyState/AdxEmptyStateV2'
import { Clear } from '@mui/icons-material'

const UnsubmittedReportTable = () => {
  const unsubmittedReportColumn = [
    {
      Header: 'Claim reports',
      accessor: 'claimReport',
      Cell: (props) => {
        const { claim_report_type, title, start_date, end_date } = props.row.original
        return isLoading ? (
          <Box display="flex" alignItems="center" height="50px">
            <Skeleton variant="text" width={300} />
          </Box>
        ) : (
          <Column1
            muiIcon={ReportIconConstructor(claim_report_type)}
            reportName={title}
            reportType={claim_report_type}
            startDate={start_date}
            endDate={end_date}
          />
        )
      },
    },
    {
      Header: 'Expense amount',
      accessor: 'totalAmount',
      Cell: (props) => {
        const { id, report_status, amount_total } = props.row.original
        return isLoading ? (
          <Box display="flex" alignItems="center" height="50px">
            <Skeleton variant="text" width={200} />
          </Box>
        ) : (
          <Column2
            reportId={id}
            status={reportStatusConverter(report_status?.name)}
            totalAmount={amount_total}
            variant={2}
          />
        )
      },
    },
  ]

  // API CALL
  const { isLoading, data } = useQuery('unsubmittedReportsData', async () => {
    const { data } = await getQueryReports({ status: 'draft' })
    return data?.reports
  })

  const navigate = useNavigate()
  const location = useLocation()
  const handleNavigate = (reportID) => {
    navigate(`/app/claim/reports/${reportID}`, {
      state: { currentLocation: location },
    })
  }

  return (
    <>
      {!isLoading && data.length === 0 ? (
        <AdxEmptyStateV2 icon={<Clear />} title="No Claim Reports" />
      ) : (
        <AdxSortTable
          stickyHeader
          height="calc(100vh - 244px)"
          column={unsubmittedReportColumn}
          data={data ? data : ['', '', '']}
          nav={
            isLoading ? (
              <Box display="flex" alignItems="center" height="50px">
                <Skeleton variant="text" width={100} />
              </Box>
            ) : (
              <Typography
                variant="body1"
                color="alternate.main"
                mr={1}
                sx={{ textDecoration: 'underline', cursor: 'pointer' }}
              >
                View
              </Typography>
            )
          }
          onClick={(e) => handleNavigate(e.id)}
        />
      )}
    </>
  )
}

export default UnsubmittedReportTable
